import VideoElementMetaData from './VideoElementMetaData';
import * as Colors from 'material-ui/styles/colors';

const presets = [
  {
    type: VideoElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 480,
      height: 270
    },
    compProps: {
      zIndex: 1,
      backgroundColor: Colors.black,
    },
    data: {
      url: 'https://www.youtube.com/embed/nJ5SjoayfJc',
      videoId: 'nJ5SjoayfJc'
    },
    hidden: false
  }
];
export default presets;
